import React from 'react';
import { Card, Grid } from '@mui/material';
import { MDBox } from 'components/MDBox';
import { MDTypography } from 'components/MDTypography';
import VOBForm from '../components/vob/VOBForm';

const VOBPage: React.FC = () => {
  return (
    <Grid container spacing={3} justifyContent="center">
      <Grid item xs={12} lg={10}>
        <MDBox mb={3}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Card>
                <MDBox p={3}>
                  <MDTypography variant="h5" fontWeight="medium" mb={1}>
                    Verification of Benefits (VOB)
                  </MDTypography>
                  <MDTypography variant="body2" color="text" mb={3}>
                    Use this form to send a Verification of Benefits to a provider. The VOB can be sent via email or fax.
                  </MDTypography>
                  <VOBForm />
                </MDBox>
              </Card>
            </Grid>
          </Grid>
        </MDBox>
      </Grid>
    </Grid>
  );
};

export default VOBPage;
